import { createContext } from 'react'
import { UseFormReturnType } from '@mantine/form'
import { OfferDecisions, WoolLotOfferDecisionCallback } from '@shared/components/offers/offer-types'

export type OfferFormDecisionContextType = {
  form?: UseFormReturnType<OfferDecisions>
  decisionCallback: WoolLotOfferDecisionCallback
}

export const OfferFormDecisionContext = createContext<OfferFormDecisionContextType>({
  form: undefined,
  decisionCallback: () => {},
})
